import { Dialog } from "primereact/dialog";
import { useDispatch, useSelector } from "react-redux";
import { setIsPaymentClearancePopupOpen } from "src/redux/slices/invoiceSlice";
import { useTranslation } from "react-i18next";
import Certificate from "src/components/Certificate/Certificate";

const PaymentClearancePopup = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation(["invoice"]);

  const isPaymentClearancePopupOpen = useSelector(
    (state: any) => state.invoices.isPaymentClearancePopupOpen
  );

  const closePopup = (): void => {
    dispatch(setIsPaymentClearancePopupOpen(false));
  };

  return (
    <Dialog
      visible={isPaymentClearancePopupOpen}
      onHide={closePopup}
      header={t("clearanceCertificate")}
      headerClassName="popup-header"
      className="certificate-popup"
    >
      <Certificate />
    </Dialog>
  );
};

export default PaymentClearancePopup;
